import { formatDate } from "@angular/common";
import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "IDate"
})
// return this format "MM/dd/yyyy";
export class IDatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) public locale: string) {}

  transform(value: Date | string | number | undefined): string {
    if (!value) {
      return "";
    }
    const date = new Date(value);
    return formatDate(date, "MM/dd/yyyy", this.locale);
  }
}
